<template>
  <v-card-text class="px-4">
    <div class="title-form mt-2 custom-font-semi-bold">Archivos adjuntos asociados</div>
    <v-divider class="mt-2 mb-3"></v-divider>
    <div class="mx-2">
      <v-data-table :items="assets" hide-actions hide-headers no-data-text="No hay datos disponibles">
        <template slot="items" slot-scope="props">
          <td><a :href="props.item.url" target="_blank">{{ props.item.name }}</a></td>
          <td class="text-xs-left">{{ props.item.description }}</td>
        </template>
      </v-data-table>
    </div>
  </v-card-text>
</template>

<script>
export default {
  props: {
    entry: Object
  },

  computed: {
    assets () {
      return (this.entry.detail) ? this.entry.detail.assets : []
    }
  }
}
</script>

<style scoped>
.title-form {
  font-size: 1.3em;
}
</style>
